import {createStore} from 'vuex'
import users from './users.store';
import roles from './roles.store'
import sms from './sms.store'
import profile from './profile.store'
import tenants from "./tenants.store"
import counties from './counties.store'
import contacts from './contacts.store'
import property_categories from './property_categories.store'
import property_typologies from './property_typologies.store'
import property_statuses from './property_statuses.store'
import properties from "./properties.store"
import property_units from './property_units.store'
import payments from "./payments.store"
import ticket_categories from './ticket_categories.store'
import ticket_channels from './ticket_channels.store'
import ticket_statuses from './ticket_statuses.store'
import tickets from './tickets.store'
import charge_types from './charge_types.store'
import charges from './charges.store'
import tenancies from './tenancies.store'
import bills from './bills.store'
import notification_types from './notification_types.store'
import settings from './settings.store'
import modules from './modules.store'
import user_types from './user_types.store'
import listings from './listings.store'
import campaigns from './campaigns.store'
import visitors from './visitors.store'
import property_settings from './property_settings.store'
import reports from './reports.store'
import tenancy from './tenancy.store'
import expense_categories from './expense_categories.store'
import vendors from './vendors.store'
import vendor_categories from './vendor_categories.store'
import expenses from './expenses.store'
import lease_templates from './lease-templates.store'
import leases from './leases.store'
import notifications from './notifications.store'
import settlements from './settlements.store'
import business_invoices from './business-invoices.store'
import landlord_invoices from './landlord-invoices.store'
import penalties from './penalties.store'
import penalty_settings from './penalty_settings.store'
import plans from './plans.store'
import business_settings from './business_settings.store'

export default new createStore({
    state: {
        autoSave: true,
        loading: {},
        clear_form: false,
        sidebar_class: ' drawer-on',
        sidebar_ref: null
    },
    getters: {
        clear_form: state => state.clear_form,
        sidebar_class: state => state.sidebar_class,
        sidebar_ref: state => state.sidebar_ref
    },
    mutations: {
        activateLoading(state, key) {
            state.loading = true;
        },
        deactivateLoading(state, key) {
            state.loading = false;
        },
        setAutoSave(state, autoSave) {
            state.autoSave = autoSave;
        },
        setClearForm(state, val) {
            state.clear_form = val
        },
        toggleSidebar(state, sidebarClass) {
            state.sidebar_class = sidebarClass
        },
        setSidebarRef(state, ref) {
            state.sidebar_ref = ref
        }
    },
    actions: {
        toggleSidebarClass({commit}, className) {
            commit('toggleSidebar', className);
        },
    },
    modules: {
        users,
        profile,
        roles,
        sms,
        tenants,
        counties,
        contacts,
        property_categories,
        property_typologies,
        properties,
        property_units,
        payments,
        ticket_categories,
        ticket_channels,
        ticket_statuses,
        tickets,
        charge_types,
        charges,
        tenancies,
        bills,
        notification_types,
        settings,
        modules,
        user_types,
        listings,
        campaigns,
        visitors,
        property_settings,
        reports,
        property_statuses,
        tenancy,
        expense_categories,
        vendors,
        vendor_categories,
        expenses,
        leases,
        lease_templates,
        notifications,
        settlements,
        business_invoices,
        landlord_invoices,
        penalties,
        penalty_settings,
        plans,
        business_settings
    }
})
